// extracted by mini-css-extract-plugin
module.exports = {"container":"pageNotFound_container__OT9XT","copyContainer":"pageNotFound_copyContainer__8c9IA","title":"pageNotFound_title__v9LVL"};